import { use } from 'react';
import FeatureFlagsContext from './FeatureFlagsContext';

/**
 * Returns whether a feature is enabled for the current fund + user.
 * Safe outside a provider (returns false) so callers never crash.
 */
const useFeature = (featureKey: string): boolean => {
  const context = use(FeatureFlagsContext);
  return context?.isEnabled(featureKey) ?? false;
};

export default useFeature;
